import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import MainLayout from '@/shared/components/MainLayout';
import TranslationPage from '@/pages/TranslationPage';
import HistoryPage from '@/pages/HistoryPage';
import RetailersPage from '@/pages/RetailersPage';
import LoginPage from '@/pages/LoginPage';
import LocalizationPage from '@/pages/LocalizationPage';
import BatchTemplatesPage from '@/pages/BatchTemplatesPage';
import ConsolidationPage from '@/pages/ConsolidationPage';
import StaticModelsPage from '@/pages/StaticModelsPage';
import { useAuth } from '@/features/auth/hooks/useAuth';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return null; // Or a loading spinner
  }

  if (!isAuthenticated) {
    return <Navigate to={{ pathname: '/login', search: location.search }} replace />;
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/localization" replace />} />
        <Route path="translation" element={<TranslationPage />} />
        <Route path="history" element={<HistoryPage />} />
        <Route path="retailers" element={<RetailersPage />} />
        <Route path="localization" element={<LocalizationPage />} />
        <Route path="sku-consolidation" element={<ConsolidationPage />} />
        <Route path="static-models" element={<StaticModelsPage />} />
        <Route path="batch-templates" element={<BatchTemplatesPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
